module.exports = __webpack_public_path__ + "static/media/logo-sandos4u.a58516b8.png";